import { Component, EventEmitter, Output } from '@angular/core';
import { isFeatureEnabled } from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  FeatureCodes,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-select-new-project',
  templateUrl: './select-new-project.component.html',
  styleUrls: ['./select-new-project.component.scss'],
})
export class SelectNewProjectComponent {
  selectedProject = '';
  @Output() addNewProject = new EventEmitter<any>();
  FeatureCodes = FeatureCodes;
  showProjectEdit: boolean = false;
  showProductEdit: boolean = false;
  isCheckProductAccessDisabled: boolean = false;
  checkEntireAccess: boolean = false;

  constructor(
    private modal: CustomModalService,
    private accessService: AccessPermissionService,
    private toaster: ToastrService
  ) {
    this.showProjectEdit = this.isProjectAccess('create');
    this.showProductEdit = this.isProductAccess('create');
    this.selectedProject = this.showProjectEdit ? 'package' : this.showProductEdit ? 'product' : '';
    if (this.showProjectEdit) {
      this.selectedProject = 'package';
    } else if (this.showProductEdit) {
      this.selectedProject = 'product';
    }
    this.isCheckProductAccessDisabled = !isFeatureEnabled(FeatureCodes.PRODUCT_PROJECT);
  }

  isProjectAccess = (type: 'view' | 'edit' | 'create' | 'delete' | 'overview') => {
    return this.accessService.hasModulePermission(
      rolesModuleName.packageScenario,
      mainModuleName.projectsModule,
      type
    );
  };

  isProductAccess = (type: 'view' | 'edit' | 'create' | 'delete' | 'overview') => {
    return this.accessService.hasModulePermission(
      rolesModuleName.productScenario,
      mainModuleName.productsModule,
      type
    );
  };

  onChangeRadio(e: any) {
    this.selectedProject = e.target.value;
  }

  onClose() {
    this.modal.close();
  }

  createProject() {
    if (!this.selectedProject) {
      this.toaster.warning('Please select a project type.');
      return;
    }
    this.modal.close();
    this.addNewProject.emit(this.selectedProject);
  }
}
